import DeviceRentalBatchPaymentPage from '@Local/DeviceRental/DeviceRentalBatchPaymentPage';
import DeviceRentalBillingPage from '@Local/DeviceRental/DeviceRentalBillingPage';
import {
    DEVICE_RENTAL_BATCH_PAYMENT_BILLING_ROUTER,
    DEVICE_RENTAL_BATCH_PAYMENT_OVERVIEW_ROUTER,
    DEVICE_RENTAL_ORDERS_OVERVIEW_ROUTER,
} from '@Router/routerPath';
import DeviceRentalOrdersOverviewPage from '@Local/DeviceRental/DeviceRentalOrdersOverviewPage';
import { FRONT_KEY } from '@Constants/frontKey';

const deviceRentalRouter = [
    {
        description: '設備租賃',
        frontKey: FRONT_KEY.DEVICE_RENTAL,
    },
    {
        description: '設備租賃批扣總覽',
        frontKey: FRONT_KEY.DEVICE_RENTAL_BATCH_PAYMENT_OVERVIEW,
        static: true,
        exact: true,
        path: DEVICE_RENTAL_BATCH_PAYMENT_OVERVIEW_ROUTER,
        href: DEVICE_RENTAL_BATCH_PAYMENT_OVERVIEW_ROUTER,
        as: DeviceRentalBatchPaymentPage,
    },
    {
        description: '銀行扣款明細',
        frontKey: FRONT_KEY.DEVICE_RENTAL_BATCH_PAYMENT_BILLING,
        static: true,
        path: DEVICE_RENTAL_BATCH_PAYMENT_BILLING_ROUTER,
        as: DeviceRentalBillingPage,
    },

    {
        description: '訂單總覽',
        frontKey: FRONT_KEY.DEVICE_RENTAL_ORDERS_OVERVIEW,
        static: true,
        exact: true,
        path: DEVICE_RENTAL_ORDERS_OVERVIEW_ROUTER,
        href: DEVICE_RENTAL_ORDERS_OVERVIEW_ROUTER,
        as: DeviceRentalOrdersOverviewPage,
    },
];

export default deviceRentalRouter;
